// extracted by mini-css-extract-plugin
export var fadeInAnimation = "MobileLayout-module--fadeInAnimation--14f8e";
export var sliderContainer = "MobileLayout-module--sliderContainer--3c571";